import { render, staticRenderFns } from "./df-page-email-change.vue?vue&type=template&id=5248aa77"
import script from "./df-page-email-change.ts?vue&type=script&lang=js&external"
export * from "./df-page-email-change.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports